import { render } from "./ChargeBanner.vue?vue&type=template&id=636536d6&scoped=true"
import script from "./ChargeBanner.vue?vue&type=script&lang=js"
export * from "./ChargeBanner.vue?vue&type=script&lang=js"

import "./ChargeBanner.vue?vue&type=style&index=0&id=636536d6&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636536d6"]])

export default __exports__